module.exports = __webpack_public_path__ + "static/img/yytx08.3742638.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/yytx08.png
// module id = 880
// module chunks = 0